import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MobileShell from "@/components/MobileShell";
import BottomNav from "@/components/BottomNav";
import api from "@/lib/api";
import { ArrowLeft, CheckCircle2 } from "lucide-react";

export default function Program() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/dashboard/me").then((r) => {
      if (!r.data?.condition) navigate("/dashboard", { replace: true });
      else setData(r.data);
    });
  }, [navigate]);

  const c = data?.condition;
  const p = c?.program || {};

  return (
    <MobileShell>
      <header className="px-6 pt-8 pb-4">
        <button onClick={() => navigate(-1)} className="text-slate-500 mb-3" data-testid="back-btn"><ArrowLeft size={20} /></button>
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-teal-600">Program overview</p>
        <h1 className="text-2xl font-bold font-display text-slate-900 mt-1">{p["Program Name"] || c?.name || "Program"}</h1>
      </header>

      <section className="px-6 space-y-3">
        <InfoCard label="Description" value={p["Description"]} />
        <InfoCard label="Who it's for" value={p["Who It Is For"]} />
        <InfoCard label="Who it's NOT for" value={p["Who It Is Not For"]} />
        <div className="grid grid-cols-2 gap-3">
          <InfoCard label="Length" value={p["Length"]} compact />
          <InfoCard label="Sessions / week" value={p["Sessions Per Week"]} compact />
        </div>
      </section>

      <section className="px-6 mt-6">
        <h3 className="text-sm font-bold uppercase tracking-wider text-slate-500">Milestones</h3>
        <ul className="mt-2 space-y-2">
          {Object.keys(p)
            .filter((k) => /milestone/i.test(k))
            .map((k) => (
              <li key={k} className="bg-white rounded-2xl border border-slate-100 p-4 flex gap-3">
                <CheckCircle2 size={18} className="text-teal-600 shrink-0 mt-0.5" />
                <div>
                  <div className="text-xs uppercase tracking-wide text-slate-500">{k}</div>
                  <div className="text-sm text-slate-900 mt-0.5">{p[k]}</div>
                </div>
              </li>
            ))}
        </ul>
      </section>

      <BottomNav />
    </MobileShell>
  );
}

function InfoCard({ label, value, compact }) {
  if (!value) return null;
  return (
    <div className={`bg-white rounded-2xl border border-slate-100 ${compact ? "p-3" : "p-4"}`}>
      <div className="text-xs uppercase tracking-wide text-slate-500">{label}</div>
      <div className={`mt-1 text-slate-900 ${compact ? "text-sm font-semibold" : "text-sm leading-relaxed"}`}>{value}</div>
    </div>
  );
}
